<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin" id="m_login">
      <div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
        <div class="m-stack m-stack--hor m-stack--desktop">
          <div class="m-login__logo" style="padding-top:16px;float:left">
                <img src="../assets/img/naos-logo-longv2.png" style="width: 200px">
              </div>
          <div class="m-login__logo" style="float:right">
                 <img src="../assets/img/CIP_Picto_fond-blanc_HD.jpg" style="width: 70px">
              </div>

          <div class="m-stack__item m-stack__item--fluid">
            <div class="m-login__wrapper">
              <div class="m-login__logo">
                Product Explorer
              </div>

              <!-- login -->
              <login v-show="currentView === 'login'"></login>
              <!-- subscribe -->
              <subscribe v-show="currentView === 'subscribe'"></subscribe>
              <!-- forgot password -->
              <forgot-password v-show="currentView === 'forgotPassword'"></forgot-password>

            </div>
          </div>
          <div class="m-stack__item m-stack__item--center">
            <!--<div class="m-login__account">-->
              <!--<span class="m-login__account-msg">-->
                  <!--Don't have an account yet ?-->
              <!--</span>&nbsp;&nbsp;-->
              <!--<router-link href="#" id="m_login_signup" class="m-link m-link&#45;&#45;focus m-login__account-link" to="/signup">Sign Up</router-link>-->
            <!--</div>-->
          </div>
        </div>
      </div>
      <div class="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1 m-login__content m-grid-item--center" id="pageWave">
        <div class="m-grid__item">
<!--          <h3 class="m-login__welcome">Join Our Community</h3>-->
<!--          <p class="m-login__msg">Lorem ipsum dolor sit amet, coectetuer adipiscing<br>elit sed diam nonummy et nibh euismod</p>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForgotPassword from './Security/ForgotPassword.vue';
import Subscribe from './Security/Subscribe.vue';
import Login from './Security/Login.vue';

export default {
  props: ['view'],
  name: 'Home',
  components: {
    ForgotPassword,
    Subscribe,
    Login,
  },
  data() {
    return {
      currentView: 'login',
      wndWidth: 0,
    };
  },
  computed: {
    logoWidth() {
      if (this.wndWidth < 370) {
        return '200px';
      } if (this.wndWidth < 1204) {
        return '250px';
      }
      return 'auto';
    },
  },
  watch: {
    view(value) {
      value ? this.currentView = value : this.currentView = 'login';
    },
  },
  methods: {
    switchView(view) { // Toggles screen views: forgot-password, login, subscribe
      this.currentView = view;
    },
  },
  created() {
    // If view prop is defined set the currentView to value
    this.view ? this.currentView = this.view : this.currentView = 'login';
    const my = this;
    my.wndWidth = $(window).width();
    window.addEventListener('resize', () => {
      my.wndWidth = $(window).width();
    });
  },
};
</script>

<style>
  @import '../assets/css/style.bundle.css';

  @font-face {
    font-family: futura;
    src: url('../assets/fonts/POLICES_FUTURA.otf');
    font-weight: bold;
  }
  .m-login__logo {
    font-size: 34px;
    font-family: futura;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue